<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/utils';

const props = defineProps<{
	class?: HTMLAttributes['class'];
}>();
</script>

<template>
	<h3
		:class="
			cn('font-matter-sq text-2xl leading-none tracking-tight', props.class)
		"
	>
		<slot></slot>
	</h3>
</template>
